import angular from 'angular';

import { routesConfig } from './sheets.import.routes';

export default angular
  .module('sheets.import', ['ui.router'])
  .config(routesConfig);
